import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { toast } from 'react-toastify';
import { Layout } from '../components/layout';
import { LogIn } from 'lucide-react';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      await login(email, password);
      toast.success('Access granted');
      
      // Check for redirect after login
      const redirectTo = sessionStorage.getItem('redirectAfterLogin');
      if (redirectTo) {
        sessionStorage.removeItem('redirectAfterLogin');
        navigate(redirectTo);
      } else {
        navigate('/');
      }
    } catch (error) {
      const message = error.response?.data?.detail || 'Authentication failed';
      toast.error(message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Layout showFooter={false}>
      <div className="min-h-[calc(100vh-64px)] flex items-center justify-center p-4">
        <div className="max-w-md w-full">
          {/* Header */}
          <div className="text-center mb-8">
            <h1 className="font-headline text-4xl text-white mb-2">
              AUTHENTICATE
            </h1>
            <p className="font-mono text-xs text-gray-500 tracking-[0.2em] uppercase">
              Secure Access Portal
            </p>
          </div>

          {/* Form Card */}
          <div className="bg-[#111] border border-[#1a1a1a] p-8 rounded">
            <form onSubmit={handleSubmit} className="space-y-6">
              <div>
                <label htmlFor="email" className="block font-mono text-xs text-[#C5A52A] mb-2 uppercase tracking-wider">
                  Email
                </label>
                <input
                  id="email"
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  className="w-full px-4 py-3 bg-black border border-[#2a2a2a] text-white font-mono text-sm focus:border-[#C5A52A] focus:outline-none transition-colors"
                  placeholder="your@email.com"
                  data-testid="login-email"
                />
              </div>

              <div>
                <label htmlFor="password" className="block font-mono text-xs text-[#C5A52A] mb-2 uppercase tracking-wider">
                  Password
                </label>
                <input
                  id="password"
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                  className="w-full px-4 py-3 bg-black border border-[#2a2a2a] text-white font-mono text-sm focus:border-[#C5A52A] focus:outline-none transition-colors"
                  placeholder="••••••••"
                  data-testid="login-password"
                />
              </div>

              <button
                type="submit"
                disabled={loading}
                className="w-full bg-[#C5A52A] hover:bg-[#D4B93A] disabled:bg-[#C5A52A]/50 text-black font-display text-sm py-3 tracking-wider transition-colors flex items-center justify-center gap-2"
                data-testid="login-submit"
              >
                <LogIn className="w-4 h-4" />
                {loading ? 'AUTHENTICATING...' : 'ACCESS'}
              </button>
            </form>

            <div className="mt-6 pt-6 border-t border-[#1a1a1a] text-center space-y-3">
              <p className="font-mono text-xs text-gray-500">
                <Link to="/forgot-password" className="text-gray-400 hover:text-white transition-colors">
                  Forgot your password?
                </Link>
              </p>
              <p className="font-mono text-xs text-gray-500">
                Not registered?{' '}
                <Link to="/register" className="text-[#C5A52A] hover:text-[#D4B93A] transition-colors">
                  CREATE ACCOUNT
                </Link>
              </p>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default Login;
